import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import configureStore from '@redux/configureStore';
import history from './history';
import adminTheme from './theme/adminTheme';
import App from './App';

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore();

// React 18 改用 createRoot API 取代 ReactDOM.render，啟用並行渲染與自動批次更新。
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={adminTheme}>
            <Provider store={store}>
                <Router history={history}>
                    <App />
                </Router>
            </Provider>
        </ThemeProvider>
    </StyledEngineProvider>
);
